import React from "react";
import { ResponsiveImage } from "@quintype/components";
import get from "lodash.get";
import { useSelector } from "react-redux";

export const ProfileImage = ({ imageUrl, defaultWidth = 255, entityName = null, isDetails = false }) => {
  const profileImg = imageUrl[0] || [];
  const imgAltText = get(profileImg, ["alt-text"], []);

  const { url: imgUrl, key: imgs3Key, metadata: imgMetaData } = profileImg;
  const fallbackImageUrl = "https://images.assettype.com/gulfnews-uat/2024-10-15/r2sl2lqd/Gulf-News-Fallback-Image.jpg";
  let style = { "border-radius": "8px 8px 0 0" };
  if (entityName === "company" || isDetails) {
    style = { borderRadius: "8px", border: "1px solid #DEE3E6" };
  }
  return (
    <div styleName="">
      {imgs3Key || imgUrl ? (
        <figure styleName="">
          {imgs3Key ? (
            <ResponsiveImage
              slug={imgs3Key}
              aspectRatio={[1, 2]}
              metadata={{ imgMetaData }}
              defaultWidth={defaultWidth}
              imgParams={{ auto: ["format", "compress"] }}
              style={style}
              alt={imgAltText}
            />
          ) : (
            <img src={imgUrl} alt="cover-image" loading="lazy" style={style} />
          )}
        </figure>
      ) : (
        <div styleName="">
          <img style={style} src={`${fallbackImageUrl}`} alt="image-fallback"></img>
        </div>
      )}
    </div>
  );
};
